module.exports = __webpack_public_path__ + "static/media/drinking.40bafcdb.mp3";